import { users } from '@mep/pae-commons';
import { Select } from 'antd';
import compose from 'lodash/fp/compose';
import map from 'lodash/fp/map';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const { USER_TYPES_ENUM } = users;

const UserTypeSelect = ({ value, related, onChange }) => {
  const { t } = useTranslation('actors');
  
  const options = useMemo(() => compose(
    map((value) => ({ value, label: t(`admin:user.form.userType.options.${value}`) })),
    values,
  )(USER_TYPES_ENUM), [t]);
  
  return (
    <Select
      disabled={related}
      value={value}
      options={options}
      onChange={onChange}/>
  );
  
};

UserTypeSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  related: PropTypes.string,
};

UserTypeSelect.defaultProps = {};

export default memo(UserTypeSelect);
